import Login from "@/views/authentication/Login.vue";
import Logout from "@/views/authentication/Logout.vue";

export default [
  {
    path: "/login",
    name: "login_path",
    component: Login
  },
  {
    path: "/logout",
    name: "logout_path",
    component: Logout
  }
];